import { Message } from 'lib-shared-legacy-types';
import { useMemo } from 'react';

import TextMessage, { TextMessageProps } from './TextMessage';
import { getAttachment } from './utils/attachment';
import { useTranslatePlainTextConversationMessage } from './utils/useTranslatePlainTextConversationMessage';

type MessageFacebookProps = {
  message: Message;
} & TextMessageProps;

export const MessageFacebook = ({
  markup,
  ...otherProps
}: MessageFacebookProps): JSX.Element => {
  const attachment = useMemo(
    () => getAttachment(otherProps.message, { scaleImage: true }),
    [otherProps.message],
  );

  const { button, translation } = useTranslatePlainTextConversationMessage({
    text: otherProps.message.text ?? undefined,
    isDisabled: !!attachment,
    originalLanguageCode: otherProps.message.language ?? null,
  });

  return (
    <TextMessage
      {...otherProps}
      content={attachment}
      gutterButtons={button}
      translation={translation}
    />
  );
};
